import { photoObjectPath } from '../../data/photos/photo-delivery';
import type { SolPhotoSourceCard } from '../../data/sol/sol-contract';

/**
 * From an AUTHORIZED photo card to the one Storage object the client may ask
 * to see. M11 / I-071, the display half.
 *
 * **THE MODEL NEVER HAD THIS.** Sol's evidence carries a photo as facts — which
 * Capture, before or after, its place, when — and not one field that could
 * locate a picture. The card the SERVER returns to the CLIENT carries a little
 * more: the `client_photo_uuid` and the source mime, which are the two halves of
 * the object name the Capture screen already derives for its own thumbnails
 * (`serverPhotoObjectPath`, M5). Putting them together here is the same
 * derivation, from the same one-place function, for the same owner.
 *
 * **THE OWNER IS THE SIGNED-IN USER, and that is not a shortcut.** Every photo
 * card was read under RLS on the caller's own token, so its owner IS the caller
 * — and the Storage policy keys the folder on `auth.uid()`, so no other folder
 * could be signed by this session in any case. The photo board uses the same
 * rule (`sessionOwnerUserId`) to name the folder it uploads into.
 *
 * Null means "no image will be asked for": no signed-in owner, or a mime the
 * pipeline never produces. A card without an image is still a photo card — it
 * keeps its label, its Capture and its link. It is never a Capture card, and
 * never a broken picture.
 */
export function solPhotoThumbPath(
  card: Pick<SolPhotoSourceCard, 'captureId' | 'clientPhotoUuid' | 'sourceMime'>,
  ownerUserId: string | null,
): string | null {
  if (ownerUserId === null || ownerUserId === '') return null;
  const mime = card.sourceMime;
  if (mime !== 'image/jpeg' && mime !== 'image/png') return null;
  return photoObjectPath(
    { ownerUserId, captureId: card.captureId, clientPhotoUuid: card.clientPhotoUuid },
    'thumb',
    mime,
  );
}
